import { faGear } from '@fortawesome/pro-solid-svg-icons';

import { UserJsVm } from '../../shared/generated/Administration/Models/User/JavaScript/UserJsVm';
import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getMainNavAdmin: () => NavRoute = () => {
    const adminNavItems: NavRoute[] = [];

    adminNavItems.push(
        {
            name: 'Admin'
            , security: security => security.adminFeatures
            , href: 'admin/dashboard'
            , icon: faGear
            , area: 'admin'
            , expanded: globalThis.location.href.includes("/admin/")
            , children: getAdminChildren()
        }
    );

    return adminNavItems[0];
};

function getAdminChildren() : NavRoute[] {
    const user = getUser();
    let navRoutes: Array<NavRoute> = [];

    navRoutes.push(
        { 
            name: 'Dashboard'
            , security: sec => sec.coreFeatures
            , exact: true
            , path: 'admin/dashboard' 
            , activeNavLink: 'admin/dashboard'
            , secondaryNav: ['Admin', 'Dashboard']
        }
        , {
            name: 'Events'
            , exact: true
            , security: security => security.adminFeatures
            , path: 'admin/events/list' 
            , activeNavLink: 'admin/events/list'
            , secondaryNav: ['Admin', 'Events', 'List']
            , children: getEventChildren()
        }
        , {
            name: 'Organizations'
            , exact: true
            , path: 'admin/global-organizations'
            , activeNavLink: 'admin/global-organizations'
            , secondaryNav: ['Admin', 'Organizations']
        }
        , {
            name: 'Org Types'
            , shortName: 'Org Types'
            , exact: true
            , path: 'admin/org-types/list'
            , activeNavLink: 'admin/org-types'
            , secondaryNav: ['Admin', 'Org Types']
        }
        , {
            name: 'Counties'
            , exact: true
            , path: 'admin/counties/list'
            , activeNavLink: 'admin/counties/list'
            , secondaryNav: ['Admin', 'Counties']
        }
        , {
            name: 'Global Audit History'
            , exact: true
            , path: 'admin/global-audit-history'
            , activeNavLink: 'admin/global-audit-history'
            , secondaryNav: ['Admin', 'Global Audit History']
        }
        , {
            name: 'NDC Database'
            , href: 'admin/ndcs/list'
            , exact: true
            , path: 'admin/ndcs/list'
            , activeNavLink: 'admin/ndcs/list'
            , secondaryNav: ['Admin', 'NDC Database']
            , expanded: globalThis.location.href.includes("/admin/ndcs/")
            , children: getNdcChildren()            
        }
        , {
            name: 'Release Notes'
            , exact: true
            , path: 'admin/release-notes/list'
            , activeNavLink: 'admin/release-notes'
            , secondaryNav: ['Admin', 'Release Notes']
        }
        , {
            name: 'SSO Logs'
            , exact: true
            , path: 'admin/sso-logs'
            , activeNavLink: 'admin/sso-logs'
            , secondaryNav: ['Admin', 'SSO Logs']
        }
        , {
            name: 'Quartz'
            , exact: true
            , path: 'quartz'
            , openNewTab: true
        }
        , {
            name: 'Quartz History'
            , exact: true
            , path: 'admin/quartz/pcg-history'
            , activeNavLink: 'admin/quartz/pcg-history'
            , secondaryNav: ['Admin', 'Quartz History']
        }
    );

    if (user?.email?.includes("@paulconsulting.com")) {
        navRoutes.push(
            {
                name: 'Admin Settings'
                , exact: true
                , path: 'admin/admin-settings'
                , activeNavLink: 'admin/admin-settings'
                , secondaryNav: ['Admin', 'Admin Settings']
            }
        );
    }

    return navRoutes;
}

function getEventChildren() {
    let id: string = "";
	let url = globalThis.location.href;

    if (
		url.includes('admin/events/edit/details/')
		|| url.includes('admin/events/edit/associations/')
		|| url.includes('admin/events/edit/inventory/')
		|| url.includes('admin/events/edit/site-reporting/')
		|| url.includes('admin/events/edit/mou/')
		|| url.includes('admin/events/edit/audit-history/')
	) { id = url.substring(url.lastIndexOf('/') + 1); } 

    if (id === "") { return; }

    if (id === "0") {
		return [
            {
				name: 'Create Event'
				, exact: true
				, path: `admin/events/create/${id}`
				, activeNavLink: 'admin/events/create'
				, secondaryNav: ['Admin', 'Events', 'Create Event']
			}
		];
	}

    let navRoutes: Array<NavRoute> = [];

    navRoutes.push(
		{
			name: 'Details'
			, exact: true
			, path: `admin/events/edit/details/${id}`
            , activeNavLink: 'admin/events/edit/details'
            , secondaryNav: ['Admin', 'Events', 'Details']
		}
        , {
			name: 'Event Organizations'
			, exact: true
			, path: `admin/events/edit/associations/${id}`
            , activeNavLink: 'admin/events/edit/associations'
            , secondaryNav: ['Admin', 'Events', 'Event Organizations']
		}
        , {
			name: 'Inventory Products'
			, exact: true
			, path: `admin/events/edit/inventory/${id}`
            , activeNavLink: 'admin/events/edit/inventory'
            , secondaryNav: ['Admin', 'Events', 'Inventory Products']
		}
        , {
			name: 'Site Reporting'
			, exact: true
			, path: `admin/events/edit/site-reporting/${id}`
            , activeNavLink: 'admin/events/edit/site-reporting'
            , secondaryNav: ['Admin', 'Events', 'Site Reporting']
		}
        , {
			name: 'MOU Language'
			, exact: true
			, path: `admin/events/edit/mou/${id}`
            , activeNavLink: 'admin/events/edit/mou'
            , secondaryNav: ['Admin', 'Events', 'MOU Language']
		}
        , {
			name: 'Audit History'
			, exact: true
			, path: `admin/events/edit/audit-history/${id}`
            , activeNavLink: 'admin/events/edit/audit-history'
            , secondaryNav: ['Admin', 'Events', 'Audit History']
		}
	);

    return navRoutes;
}

function getNdcChildren() : NavRoute[] {
	let id: string = "";
	let url = globalThis.location.href;
	if (url.includes('admin/ndcs/edit/')) { id = url.substring(url.lastIndexOf('/') + 1); }

	if (id === "") { return null!; }

	return [
		{
			name: 'NDC Database'
			, exact: true
			, path: `admin/ndcs/list`
			, activeNavLink: 'admin/ndcs/list'
			, secondaryNav: ['Admin', 'NDC Database']
		}
		, {
			name: 'NDC Info'
			, exact: true
			, path: `admin/ndcs/edit/${id}`
			, activeNavLink: 'admin/ndcs/edit'
			, secondaryNav: ['Admin', 'NDC Database', 'NDC Info']
		}		
	];
}

function getUser(): UserJsVm {
	const userJson: string | null = localStorage.getItem('user');
	if (userJson !== null) { return JSON.parse(userJson); }
	return null!;
}
